import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Video blogging",
  "description": "",
  "published": "2007-02-18T00:00:00.000Z",
  "redirect_from": ["/blog/video-blogging/swizec/285"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A few days ago I decided to give video ranting a go and after having videod three rants in a matter of fiteeen minutes this morning I'm rather certain this new thing is here to stay. It's easier, better, and it makes me look sillier. The only problem is I don't have boobies and people seem to enjoy those the most in such things, but I'm sure some can be procured.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      